import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';
import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class UserParam extends Model {
  @Expose()
  id: number;

  @Expose()
  creationTemplate: ShipmentCreationTemplateTypes;

  @Expose()
  name: string;

  @Expose()
  key: string;

  @Expose()
  value: string;
}
